// Real Cafe Anh photos provided by the owner
export const photos = {
  interior:
    "https://customer-assets.emergentagent.com/job_cafe-anh-helsinki/artifacts/wbgea7mc_7a69f6a9-b411-408f-967c-5f02b13a1970.JPG",
  cappuccinoCroissant:
    "https://customer-assets.emergentagent.com/job_cafe-anh-helsinki/artifacts/o25rlvlz_4b4066a4-a411-42df-b474-50ab20c6b551.JPG",
  icedCoffeeGlass:
    "https://customer-assets.emergentagent.com/job_cafe-anh-helsinki/artifacts/7suuc01f_7a081534-c4c1-4839-b5c6-7ed0a33119cf.JPG",
  twoVietnameseCoffees:
    "https://customer-assets.emergentagent.com/job_cafe-anh-helsinki/artifacts/7r7dy2m1_10c244e8-71d8-4766-adc2-2000e4521aa7.JPG",
  matchaFlan:
    "https://customer-assets.emergentagent.com/job_cafe-anh-helsinki/artifacts/w92txt01_14a86a0e-3bcc-4dff-8013-0c2833b3770a.JPG",
};

// Drinks menu — real prices
export const drinksMenu = [
  {
    name: "Vietnamese Iced Coffee",
    vn: "Cà phê sữa đá",
    desc: "Strong dark roast slow-dripped over sweet condensed milk and ice. The signature.",
    price: "5.50",
    image: photos.twoVietnameseCoffees,
    featured: true,
  },
  {
    name: "Bạc Xỉu",
    vn: "Saigon white coffee",
    desc: "A gentler version of cà phê sữa — more milk, less coffee, perfectly balanced.",
    price: "5.90",
    image: photos.icedCoffeeGlass,
    featured: true,
  },
  {
    name: "Egg Coffee",
    vn: "Cà phê trứng",
    desc: "Velvet whipped egg yolk over hot Vietnamese coffee. A Hanoi classic.",
    price: "6.00",
    image: photos.cappuccinoCroissant,
    featured: true,
  },
  {
    name: "Coconut Coffee",
    vn: "Cà phê dừa",
    desc: "Iced coffee blended with creamy coconut — tropical, smooth and not too sweet.",
    price: "6.50",
    image: photos.matchaFlan,
    featured: true,
  },
  {
    name: "Lemon Tea",
    vn: "Trà chanh",
    desc: "Bright, refreshing iced lemon tea — the easy companion to banh mi.",
    price: "4.50",
  },
  {
    name: "Cappuccino",
    vn: "Classic espresso & milk",
    desc: "Smooth espresso with silky steamed milk — for the days you want it familiar.",
    price: "4.90",
  },
];

export const foodMenu = [
  {
    name: "Banh Mi",
    vn: "Bánh mì",
    desc: "Crisp baguette, house pâté, cold cuts, pickled daikon-carrot, coriander and chili.",
    price: "9.50",
  },
  {
    name: "Pho Bo",
    vn: "Phở bò",
    desc: "Slow-simmered beef bone broth, rice noodles, fresh herbs and lime.",
    price: "13.90",
  },
  {
    name: "Brownie Bar",
    vn: "Dark chocolate",
    desc: "Dense, fudgy brownie square — the perfect pairing for a cà phê sữa đá.",
    price: "4.90",
  },
  {
    name: "Croissant",
    vn: "Daily-baked",
    desc: "Buttery, flaky croissant served warm with your morning coffee.",
    price: "3.90",
  },
];

export const galleryImages = [
  {
    src: photos.interior,
    alt: "Cafe Anh interior with the wooden slat wall and signature sign — Vietnamese coffee shop in Helsinki",
    span: "md:col-span-7 md:row-span-2",
  },
  {
    src: photos.twoVietnameseCoffees,
    alt: "Two Vietnamese iced coffees in textured glasses at Cafe Anh Helsinki",
    span: "md:col-span-5",
  },
  {
    src: photos.cappuccinoCroissant,
    alt: "Cappuccino and freshly baked croissant on a wooden tray",
    span: "md:col-span-5",
  },
  {
    src: photos.icedCoffeeGlass,
    alt: "Vietnamese iced coffee in a crystal-cut glass — Cafe Anh, Kallio",
    span: "md:col-span-6",
  },
  {
    src: photos.matchaFlan,
    alt: "Matcha latte with Vietnamese flan crème caramel at Cafe Anh",
    span: "md:col-span-6",
  },
];

export const reviews = [
  {
    quote:
      "Friendly owners and the warmest service in Helsinki — welcome cookies on the table, free tea refills, and a smile every time. It felt like being invited into someone's home.",
    name: "Verified Google review",
  },
  {
    quote:
      "Authentic Vietnamese coffee — the bạc xỉu and cà phê sữa đá are spot on. Balanced, not overly sweet, brewed with care. Easily my favourite café in Kallio.",
    name: "Verified Google review",
  },
  {
    quote:
      "Genuinely one of the best phở places in Helsinki. Clear broth, deep flavour, real herbs. A cosy little family-run spot — worth the trip up Hämeentie.",
    name: "Verified Google review",
  },
];

export const hoursDetails = [
  { day: "Monday — Friday", time: "08:00 — 19:00" },
  { day: "Saturday — Sunday", time: "10:00 — 18:00" },
];

export const business = {
  name: "Cafe Anh",
  tagline: "Vietnamese coffee shop in Helsinki",
  neighbourhood: "Kallio",
  address: "Hämeentie 30, 00530 Helsinki",
  addressShort: "Hämeentie 30",
  phone: "045 3151528",
  phoneTel: "+358453151528",
  email: "hello@cafeanh.fi",
  priceRange: "€5 — €10",
  rating: "4.8",
  reviewsCount: "193",
  hoursLine: "Mon–Fri 08:00 – 19:00 · Sat–Sun 10:00 – 18:00",
  hoursShort: "Open today · until 19:00",
  services: "Dine-in & takeaway · No delivery",
  mapEmbed:
    "https://www.google.com/maps?q=Cafe+Anh+H%C3%A4meentie+30,+00530+Helsinki&output=embed",
  mapLink:
    "https://www.google.com/maps/search/?api=1&query=Cafe+Anh+H%C3%A4meentie+30%2C+00530+Helsinki",
  instagram: "https://instagram.com",
  facebook: "https://facebook.com",
};
